/**
 * Legal pages: Terms of Service and Privacy Policy.
 * Based on the text supplied by ReTax360 (Terms updated Apr 23, 2025; Privacy effective Apr 24, 2025), revised
 * so every statement matches how ReTax360 and this website actually operate. See docs/LEGAL-REVIEW-NOTES.md.
 * Reviewed and approved by ReTax360 for publication (September 2026).
 * To change wording, edit terms.ts / privacy.ts and update LEGAL_UPDATED.
 */
import { eyebrow } from '../../components/primitives';
import { SITE_CONFIG } from '../../config/site-config';
import { routeHref } from '../../lib/links';
import { legalEmailLink, privacyLink, termsLink } from './legal-links';
import { PRIVACY } from './privacy';
import { TERMS } from './terms';

const LEGAL_UPDATED = 'September 27, 2026';

export type LegalDocument = 'privacy' | 'terms';

export function pageLegal(document: LegalDocument): string {
  const isPrivacy = document === 'privacy';
  const secs = isPrivacy ? PRIVACY() : TERMS();
  const other = isPrivacy ? `See also our ${termsLink()}.` : `See also our ${privacyLink()}.`;
  return `
  <section class="hero compact legal-hero" aria-labelledby="h1">
    <div class="wrap rv">
      ${eyebrow('Legal')}
      <h1 id="h1" style="margin-top:20px">${isPrivacy ? 'Privacy Policy' : 'Terms of Service'}</h1>
      <p class="lede" style="margin-top:18px">Last updated ${LEGAL_UPDATED}</p>
      <p class="legal-meta">${other} Questions: ${legalEmailLink()}</p>
    </div>
  </section>
  <section class="s" style="padding-top:40px">
    <div class="wrap legal-layout">
      <nav class="legal-toc" aria-label="On this page">
        <p class="colh">On this page</p>
        ${secs.map(([id, h]) => `<a href="${routeHref((isPrivacy ? '/privacy' : '/terms') + '#' + id)}">${h}</a>`).join('')}
      </nav>
      <article class="legal-doc">
        ${secs.map(([id, h, body]) => `<section id="${id}" class="legal-sec"><h2>${h}</h2>${body}</section>`).join('')}
        <p class="legal-foot">© ${SITE_CONFIG.COPYRIGHT_YEAR} ${SITE_CONFIG.LEGAL_NAME}. Last updated ${LEGAL_UPDATED}.</p>
      </article>
    </div>
  </section>`;
}
